<div class="p-6 sm:p-8 max-w-4xl">
    <!-- Title -->
    <div class="text-center mb-6 sm:mb-8">
        <div class="w-16 h-16 mx-auto mb-4 bg-amber-100 rounded-full flex items-center justify-center">
            <mat-icon class="text-amber-600 icon-size-8" [svgIcon]="'heroicons_outline:clock'"></mat-icon>
        </div>
        <h2 class="text-2xl sm:text-3xl font-bold tracking-tight">{{ 'features.trial_end.title' | transloco }}</h2>
        <p class="mt-2 text-secondary text-sm sm:text-base">{{ 'features.trial_end.subtitle' | transloco }}</p>
    </div>

    <!-- Plan cards -->
    <div class="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6">
        <div *ngFor="let plan of plans"
             class="relative flex flex-col p-5 sm:p-6 rounded-xl border-2 transition-all duration-200"
             [ngClass]="{
                 'border-primary shadow-lg scale-[1.02]': plan.highlighted,
                 'border-gray-200 hover:border-gray-300': !plan.highlighted
             }">

            <!-- Recommended badge -->
            <span *ngIf="plan.highlighted"
                  class="absolute -top-3 left-1/2 -translate-x-1/2 bg-primary text-white text-xs font-bold px-3 py-1 rounded-full shadow-sm whitespace-nowrap">
                {{ 'features.trial_end.recommended' | transloco }}
            </span>

            <!-- Plan name and price -->
            <div class="text-center mb-4">
                <h3 class="text-lg font-semibold">{{ plan.nameKey | transloco }}</h3>
                <!-- Real monthly price excluding tax, in the partner's currency; blank until known -->
                <p class="text-2xl font-bold mt-1" [ngClass]="{'text-primary': plan.highlighted}">
                    @if (prices[plan.planCode]; as price) {
                        {{ price.amount }}@if (!price.free) {<span class="text-sm font-normal text-secondary"> {{ 'settings-partner.subscription.pricing.per-month-excl-tax' | transloco }}</span>}
                    } @else {
                        &nbsp;
                    }
                </p>
                <p class="text-xs text-secondary mt-1">{{ plan.descriptionKey | transloco }}</p>
            </div>

            <!-- Features list -->
            <ul class="flex-grow space-y-2 mb-6">
                <li *ngFor="let feature of plan.features" class="flex items-start text-sm">
                    <mat-icon class="icon-size-4 mr-2 mt-0.5 flex-shrink-0"
                              [ngClass]="{'text-primary': plan.highlighted, 'text-green-500': !plan.highlighted}"
                              [svgIcon]="'heroicons_outline:check'"></mat-icon>
                    <span>{{ feature | transloco }}</span>
                </li>
            </ul>

            <!-- CTA button -->
            <button mat-flat-button
                    [color]="plan.highlighted ? 'primary' : undefined"
                    class="w-full"
                    [ngClass]="{'mat-stroked': !plan.highlighted}"
                    (click)="selectPlan(plan.planCode)">
                {{ plan.ctaKey | transloco }}
            </button>
        </div>
    </div>
</div>
